import { QueryClient } from '@tanstack/react-query';

import { isRetryableApiError } from 'queries/apiQuery';

export const MAX_QUERY_RETRIES = 2;
export const DEFAULT_STALE_TIME = 30 * 1000;

/**
 * The app's single QueryClient.
 *
 * Focus refetching is off because dispatchers leave this screen open for hours and every tab
 * switch would otherwise re-request the board. Retries are bounded and limited to failures that
 * can plausibly succeed on a second attempt, so a 404 or a 400 never costs three round trips.
 *
 * Exported as a factory as well as an instance so tests can build an isolated client.
 */
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => failureCount < MAX_QUERY_RETRIES && isRetryableApiError(error),
      },
    },
  });

export const queryClient = createQueryClient();
